import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSort } from '@angular/material/sort';
import { DataBagService } from 'src/app/common/data-bag.service';
import { ProductService } from '../product.service';
import { InfoboxService } from '../../../common/infobox/infobox.service';
import { LoaderService } from '../../../common/loader/loader.service';

export interface PeriodicElement {
	name: string;
	weight: number;
	symbol: string;
}

@Component({
	selector: 'app-product-multimedias',
	templateUrl: './product-multimedias.component.html',
	styleUrls: ['./product-multimedias.component.css'],
})
export class ProductMultimediasComponent {
	@Input() editable = true;
	@Output() dataChanged = new EventEmitter();
	@ViewChild('dataTable') table: MatTable<PeriodicElement>;
	@ViewChild(MatSort) sort: MatSort;

	photo = '';
	displayedColumns: string[] = [`url`, 'link', `edit`];

	constructor(
		private readonly bag: DataBagService,
		public service: ProductService,
		private readonly infobox: InfoboxService,
		private readonly loader: LoaderService,
	) {}

	dropTable(event: CdkDragDrop<PeriodicElement[]>): void {
		moveItemInArray(this.service.data.productMultimedias, event.previousIndex, event.currentIndex);
		this.table.renderRows();
	}

	async uploadFile(event): Promise<void> {
		this.loader.show('image-uploading');

		const totalFiles = event.target.files.length;

		let successfulRequests = 0;
		let errorOccurred = false;

		const uploadPromises: Promise<void>[] = [];
		const errorMessages: string[] = [];

		for (let i = 0; i < totalFiles; i++) {
			uploadPromises.push(
				new Promise((resolve, reject) => {
					this.bag.upload('/multimedia/file/', event.target.files[i], (result, error) => {
						if (error) {
							errorOccurred = true;

							const parsed = JSON.parse(error.error[0]);

							errorMessages.push(
								parsed.name[0].message.includes('Invalid file type')
									? 'Nieobsługiwany format pliku. \n'
									: 'Wystąpił nieoczekiwany błąd. \n',
							);
						} else {
							this.photo = result.url;
							this.service.data.productMultimedias.push({
								id: null,
								multimedia: result,
								order: this.service.data.productMultimedias.length + i + 1,
							});
							successfulRequests++;

							this.table.renderRows();
						}
						resolve();
					});
				}),
			);
		}
		await Promise.all(uploadPromises);
		this.loader.hide('image-uploading');

		if (errorOccurred && successfulRequests < totalFiles) {
			this.infobox.error(`Podczas wgrywania zdjęć, wystąpiły poniższe błędy: \n ${errorMessages.join('\n')}`);
		} else {
			this.infobox.success('Pomyślnie wgrano zdjęcia!');
		}
	}

	deleteImage(index) {
		this.service.data.productMultimedias.splice(this.service.data.productMultimedias.indexOf(index), 1);
		this.table.renderRows();
	}
}
